module.exports = __webpack_public_path__ + "static/img/modal_bgthai.b96068d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hongbao/img/modal_bgthai.png
// module id = crhZ
// module chunks = 1